import Helpers from '@Apis/helpers';
import Constants from '@Apis/constants';

/**
 * @param page
 * @param entityId
 * @param entityType
 * @param addressId
 * @param payload
 */
class AddressServices {
    getAddresses = async (page, entityId, entityType, addressId) => {
      const addresses = await Helpers.get({
        url: `${Constants.ADDRESS}?limit=30&page=${page || '1'}${entityId ? `&entity_id=${entityId}` : ''}${entityType ? `&entity_type=${entityType}` : ''}${addressId ? `&address_id=${addressId}` : ''}`,
      });
      return addresses;
    }

    /**
     *
     * @param payload
     * @return {Promise<*>}
     */
    createAddress = async (payload) => {
      const address = await Helpers.post({
        url: Constants.ADDRESS,
        data: payload,
      });
      return address;
    }

    /**
     *
     * @param payload
     * @return {Promise<*>}
     */
    updateAddress = async (payload) => {
      const address = await Helpers.put({
        url: Constants.ADDRESS,
        data: payload,
      });
      return address;
    }
}
export default new AddressServices();
